<template>
  <div>
    <div class="right-title">
      <span>简历投递统计</span>
    </div>
    <div class="content-box">

      <div class="chiose-box">
        <div>
          双选会：
          <el-select v-model="value" placeholder="请选择">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
        <el-date-picker
          v-model="timer"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>

      </div>
      <div class="num">
        <span>总数量<br/> <b>{{num1}}</b></span>
        <span>双选会数量<br/> <b>{{num2}}</b></span>
      </div>
      <div id="container"></div>
    </div>
    <footerBox class="footer"/>
  </div>
</template>

<script>
  import footerBox from '../components/rightBottom'
  import HighCharts from 'highcharts'

  export default {
    name: "tongjiList",
    data() {
      return {

        value:'',
        options:[],
        num1: 0,
        num2: 0,
        timer: '',
        type: 1,
        startTime: '',
        endTime: '',
        option: {
          credits: {
            enabled: false
          },
          chart: {
            type: 'areaspline'
          },
          title: {
            text: ''
          },
          exporting: {
            enabled: false
          },
          legend: {
            align: 'center',
            verticalAlign: 'top',
            top: 400,
            right: 10,
            bottom: 50,
          },
          xAxis: {
            categories: []
          },
          yAxis: {
            title: {
              text: '数量'
            },
            labels: {
              formatter: function () {
                return this.value;
              }
            }
          },
          tooltip: {
            crosshairs: true,
            shared: true
          },
          plotOptions: {
            spline: {
              marker: {
                radius: 4,
                lineColor: '#666666',
                lineWidth: 1
              }
            }
          },
          series: [{
            name: '总数量',
            data: [],
            color: '#ffb89e'
          }, {
            name: '双选会数量',
            data: [],
            color: '#3d9bde'
          }]
        },
      }
    },
    computed: {
      user() {
        return this.$store.state.user
      },

    },
    created() {
      this.$emit('setType', 4)
      this.getNum()
      this.getList()
    },
    mounted() {
      // this.chart = new HighCharts.chart('container', this.option)
      // HighCharts.chart('container', this.option)
      // this.option.series = this.chartData
      // this.chart = new HighCharts.chart('container', this.option)
    },
    methods: {

      //  获取双选会列表
      getList(){
        this.$api.apiContent.listCustomSXH({
          page: 1,
          pageSize: 10000,
          adminId: this.user.id,
        }).then(res => {
          res.data.map(item=>{
            this.options.push({
              value: item.id,
              label: item.name
            })
          })

        }).catch(() => {

        })
      },


      getNum() {
        this.$api.apiContent.resumeDeliveryStatistics({
          adminId: this.user.id,
          sxhId:this.value,
          startTime: this.startTime,
          endTime: this.endTime
        }).then(res => {
          this.option.xAxis.categories = []
          this.option.series[0].data = []
          this.option.series[1].data = []
          this.num1 = 0
          this.num2 = 0
          res.data.map(item => {
            this.option.xAxis.categories.push(item.date)
            this.option.series[0].data.push(item.resumeNum)
            this.option.series[1].data.push(item.resumeSXHNum)
            this.num1 += item.resumeNum
            this.num2 += item.resumeSXHNum
          })
          this.chart = new HighCharts.chart('container', this.option)
        }).catch(e => {
          console.log(e)
        })
      },
    },
    watch: {
      timer() {
        if (this.timer) {
          this.startTime = this.$tools.ZHDate(this.timer[0])
          this.endTime = this.$tools.ZHDate(this.timer[1])
        } else {
          this.startTime = ''
          this.endTime = ''
        }
        this.getNum()
      },
      value(){
        this.getNum()
      }
    },
    components: {
      footerBox
    }
  }
</script>

<style scoped lang="scss">
  .content-box {
    .chiose-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 20px 0;

      div {
        display: flex;
        align-items: center;
        margin-left: 30px;

        a {
          display: block;
          width: 80px;
          height: 40px;
          text-align: center;
          line-height: 40px;
          border: 1px solid #00a2ea;
          color: #00a2ea;

          &:first-child {
            border-right: 0;
          }

          &.active {
            background: #00a2ea;
            color: #fff;
          }
        }
      }
    }

    .num {
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 80px;
      border-top: 1px solid #e2e2e2;
      border-bottom: 1px solid #e2e2e2;

      span {
        font-size: 16px;
        text-align: center;

        b {
          display: block;
          font-size: 18px;
          font-weight: bold;
          margin-top: 10px;
        }
      }
    }
  }
</style>